import React from 'react';
import { Habit } from '../utils/storage';
import { getWeekCompletions, getLast7Days, getTodayStr } from '../utils/habits';
interface WeeklyGridProps {
  habit: Habit;
  onCompleteToday?: () => void;
}
export const WeeklyGrid: React.FC<WeeklyGridProps> = ({
  habit,
  onCompleteToday
}) => {
  const completions = getWeekCompletions(habit);
  const days = getLast7Days();
  const today = getTodayStr();
  const dayLabels = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
  // Align labels with actual days (simplified, assuming last 7 days ending today)
  const todayDate = new Date();
  const todayDayOfWeek = todayDate.getDay(); // 0 is Sunday
  // Generate labels ending on today
  const alignedLabels = Array.from({
    length: 7
  }).map((_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (6 - i));
    return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][d.getDay()];
  });
  return <div className="flex flex-col items-center space-y-2" data-id="element-48">
      <div className="flex space-x-2" data-id="element-49">
        {completions.map((isCompleted, index) => {
        const isToday = days[index] === today;
        const isTappable = isToday && !isCompleted && !!onCompleteToday;
        return <div key={days[index]} className="flex flex-col items-center space-y-1" data-id="element-50">
              <div onClick={isTappable ? onCompleteToday : undefined} className={`w-6 h-6 rounded-md flex items-center justify-center transition-all duration-300 ${isCompleted ? 'bg-[#6B8F71] shadow-sm' : isToday ? `bg-white border-2 border-[#6B8F71]/40 ${isTappable ? 'cursor-pointer hover:bg-[#6B8F71]/10 active:scale-90' : ''}` : 'bg-gray-100'}`} data-id="element-51" />
              <span className={`text-[10px] ${isToday ? 'font-bold text-gray-900' : 'text-gray-400'}`} data-id="element-52">
                {alignedLabels[index]}
              </span>
            </div>;
      })}
      </div>
    </div>;
};